import { Box, Typography } from '@mui/material'
import React from 'react'
import blogo from '../Assests/logo.jpg';
import { CLIENT_NAME } from '../config/clientInfo';

function HomeReport() {
    return (
        <>
            <Box sx={{
                height: '82vh',
                background: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',

            }}>
                <img
                    src={blogo}
                    alt={`${CLIENT_NAME} Logo`}
                    draggable={false}
                    width='240px'
                    style={{ borderRadius: '50%', aspectRatio: '1', objectFit: 'contain' }}
                />
                <Typography sx={{
                    fontSize: { md: '50px', xs: '35px' },
                    color: 'primary.main',
                    fontWeight: 'bold',
                    fontFamily: 'Kanit, sans-serif'
                }}>
                    {CLIENT_NAME} - Reports
                </Typography>
            </Box>


        </>
    )
}

export default HomeReport
